export default __webpack_public_path__ + "static/media/yk.e00a0dae.jpg";